// External Imports
import { Axios, AxiosResponse } from "axios";

// Internal Imports
import { addUrlQuery } from "../utils";
import { Query } from "../types/query";

export interface TransactionsInterface {
  getAll: (query?: Query) => Promise<any>;
}

export const transactions = (client: Axios): TransactionsInterface => ({
  getAll: async (query?: Query) => {
    const url = addUrlQuery(`/transactions`, query);
    const { data }: AxiosResponse = await client.get(url);
    return data;
  }
});
